<template>
  <div class="com">
    <div class="box" v-loading="loading" :style="{ height: (contenitoreHeight - 20) + 'px' }">
      <div class="col-24 com-title">
        <span>{{ getTitle() }}</span>
      </div>
      <div class="box-documents">
        <div class="gridMessage">
          <div class="row row-custom msgDetail">
            <div class="padding-2 col-24" v-for="(item, index) in messaggi" :key="index">
              <el-card shadow="never" :class="{ important: isImportant(item) }"
                @click.native="isMobile() ? selectMessage(item, index) : ''">
                <div class="card-testata col-24">
                  <div class="titolo">
                    {{ item.titolo.toUpperCase() }}
                  </div>
                  <div class="priorita" v-if="(item.priorita === '1')">
                    <icon name="riv-preferitiFull" scale="0.8"></icon>
                  </div>
                  <div class="allegati" v-if="(item.allegati.length > 0)">
                    <icon name="riv-attach" scale="1"></icon>
                  </div>
                  <div class="presa-vis" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'N')">
                    <icon name="riv-acceptView" scale="1"></icon>
                  </div>
                  <div class="presa-vis-yes" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'Y')">
                    <icon name="riv-read" scale="1"></icon>
                  </div>
                </div>
                <div class="col-24 testo truncate" v-html="item.testo"></div>
                <div class="col-24 footer no-padding">
                  <div class="data">
                    {{ $t('messages')[new Date(item.dataPub.substr(0, 4), parseInt(item.dataPub.substr(5, 2)) - 1,
                      item.dataPub.substr(8, 2)).getDay()] + ', ' + moment(item.dataPub,
                    'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
                  </div>
                  <el-button v-if="!isMobile()" class="custom-button" type="primary"
                    @click.native="selectMessage(item, index)">{{ $t('messages.btn.leggi') }}</el-button>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="menu-trasferta">
      <div class="action" @click="openTab('1')" :class="tabActive === '1' ? 'selected' : ''">
        <div class="box border-r">
          <div class="boxIcon counter-nuovi">
            <el-badge :value="counterNonLetti" class="item" :hidden="(counterNonLetti <= 0)">
              <icon name="riv-messClsd" scale="2"></icon>
            </el-badge>
          </div>
          <span> {{ $t('messages.nuovi').toUpperCase() }}</span>
        </div>
      </div>
      <div class="action" @click="openTab('2')" :class="tabActive === '2' ? 'selected' : ''">
        <div class="box border-r">
          <div class="boxIcon">
            <icon name="riv-messOpen" scale="2"></icon>
          </div>
          <span>{{ $t('messages.letti').toUpperCase() + ((counterLetti > 0) ? (' (' + counterLetti + ')') : '')
            }}</span>
        </div>
      </div>
      <div class="action" @click="openTab('3')" :class="tabActive === '3' ? 'selected' : ''">
        <div class="box">
          <div class="boxIcon counter-bacheca">
            <el-badge :value="counterAnnunciNonLetti" class="item" :hidden="(counterAnnunciNonLetti <= 0)">
              <icon name="riv-voice" scale="2"></icon>
            </el-badge>
          </div>
          <span>{{ $t('messages.annunci').toUpperCase() + ((counterAnnunci > 0) ? (' (' + counterAnnunci + ')') :
            '')}}</span>
        </div>
      </div>
    </div>

    <el-dialog v-if="isMobile()" class="modal-message-mobile mobile_customize" :visible.sync="showModal"
      @close="closeMessages" :append-to-body="true" :title="messaggio.titolo.toUpperCase()" custom-class="custom-dialog"
      :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">

      <div class="col-24 no-padding data">
        {{ $t('messages')[new Date(messaggio.dataPub.substr(0, 4), parseInt(messaggio.dataPub.substr(5, 2)) - 1,
          messaggio.dataPub.substr(8, 2)).getDay()] + ', ' + moment(messaggio.dataPub,
            'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
      </div>
      <div class="col-24 no-padding data" v-if="(messaggio.hasOwnProperty('dataExp'))">
        {{ $t('messages.scade') + ' ' + moment(messaggio.dataExp, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
      </div>
      <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
      <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
        <div v-for="mess in messaggio.allegati" :key="mess.keyDoc">
          <div class="col-24 no-padding allegato" @click="getAllegato(mess)">
            <icon class="icona" name="riv-attach" scale="1"></icon>
            <div class="titolo-allegato">
              {{ mess.titolo }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <div class="col-24 no-padding">
          <el-button class="mobile-el-button primary"
            v-if="(messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'N')"
            @click.native="setMessaggioService(messaggio, 'P', true)">{{ $t('messages.btn.presaVisione') }}</el-button>
          <div v-else class="no-button" style="height:80px"></div>
          <el-button class="mobile-el-button secondary" @click="closeMessages()">{{ $t('messages.btn.close')
            }}</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'
import { bus } from "./Bus";
import mixinDownload from "../assets/mixins/downloadDoc.js";

export default {
  components: {},
  mixins: [mixinDownload],
  name: 'Comunicazioni',
  props: ['contenitoreHeight', 'showInDashboard'],
  i18n: {
    messages: {
      it_IT: {
        messages: {
          nuovi: 'Nuovi',
          letti: 'Letti',
          bacheca: 'Bacheca',
          annunci: 'Annunci',
          download: 'Leggi',
          pubblicazione: 'Pubblicato il: ',
          scadenza: 'Scade il:',
          btn: {
            annulla: 'Annulla',
            presaVisione: 'Presa Visione',
            leggi: 'Leggi',
            close: 'Chiudi'
          },
          elimina: 'Elimina',
          scade: 'Scade il',
          ricevuto: 'Ricevuto il',
          presaVisione: 'Presa Visione',
          1: 'Lunedì',
          2: 'Martedì',
          3: 'Mercoledì',
          4: 'Giovedì',
          5: 'Venerdì',
          6: 'Sabato',
          0: 'Domenica'
        }
      },
      fr_FR: {
        messages: {
          nuovi: 'Nouveau',
          letti: 'Lu',
          bacheca: 'Petites Ann.',
          annunci: 'Annonces',
          download: 'Lois',
          pubblicazione: 'Pubblicato il: ',
          scadenza: 'Scade il:',
          btn: {
            annulla: 'Annule',
            presaVisione: 'Presa Visione',
            leggi: 'Lire',
            close: 'Fermer'
          },
          elimina: 'Éliminer',
          scade: 'Expire le',
          ricevuto: 'Reçu le',
          presaVisione: 'Presa Visione',
          1: 'Lundi',
          2: 'Mardi',
          3: 'Mercredi',
          4: 'Jeudi',
          5: 'Vendredi',
          6: 'Sabbat',
          0: 'Dimanche'
        }
      },
      es_ES: {
        messages: {
          nuovi: 'Nuevos',
          letti: 'Leidos',
          bacheca: 'Prioritari',
          annunci: 'Anuncios',
          download: 'Leyes',
          pubblicazione: 'Publicado el : ',
          scadenza: 'Caduca el:',
          btn: {
            annulla: 'Anular',
            presaVisione: 'Presa Visione',
            leggi: 'Leer',
            close: 'Cierra'
          },
          elimina: 'Eliminar',
          scade: 'Vence el',
          ricevuto: 'Recibido el',
          presaVisione: 'Presa Visione',
          1: 'Lunes',
          2: 'Martes',
          3: 'Miércoles',
          4: 'Jueves',
          5: 'Viernes',
          6: 'Sábado',
          0: 'Domingo'
        }
      },
      de_DE: {
        messages: {
          nuovi: 'Neu',
          letti: 'Gelesen',
          bacheca: 'Schwarzes Brett',
          annunci: 'Anzeigen',
          download: 'Download',
          pubblicazione: 'Publicado el : ',
          scadenza: 'Caduca el:',
          btn: {
            annulla: 'Anular',
            presaVisione: 'Presa Visione',
            leggi: 'Lesen',
            close: 'Schließen'
          },
          elimina: 'Beseitigen',
          scade: 'Läuft am ab',
          ricevuto: 'Eingegangen am',
          presaVisione: 'Presa Visione',
          1: 'Montag',
          2: 'Dienstag',
          3: 'Mittwoch',
          4: 'Donnerstag',
          5: 'Freitag',
          6: 'Sabbat',
          0: 'Sonntag'
        }
      },
      en_GB: {
        messages: {
          nuovi: 'New',
          letti: 'Read',
          bacheca: 'Notice Board',
          annunci: 'Annunci',
          download: 'Download',
          pubblicazione: 'Publicado el : ',
          scadenza: 'Caduca el:',
          btn: {
            annulla: 'Anular',
            presaVisione: 'Presa Visione',
            leggi: 'Read',
            close: 'Close'
          },
          elimina: 'Remove',
          scade: 'Expires',
          ricevuto: 'Received on',
          presaVisione: 'Presa Visione',
          1: 'Monday',
          2: 'Tuesday',
          3: 'Wednesday',
          4: 'Thursday',
          5: 'Friday',
          6: 'Saturday',
          0: 'Sunday'
        }
      }
    }
  },
  data() {
    return {
      moment: moment,
      loading: false,
      activeTab: 'nuovi',
      /*msg: {
        titolo: '',
        dataPub: '',
        dataExp: '',
        testo: '',
        allegati: []
      },*/
      messaggio: {
        titolo: '',
        dataPub: '',
        dataExp: '',
        testo: '',
        allegati: []
      },
      showModal: false,
      messageDialogVisible: false,
      messaggi: [],
      messaggiLetti: [],
      messaggiBacheca: [],
      messaggiNonLetti: [],
      messaggiAnnunci: [],
      counterLetti: 0,
      counterBacheca: 0,
      counterNonLetti: 0,
      counterAnnunci: 0,
      counterAnnunciNonLetti: 0,
      codLang: (sessionStorage.hasOwnProperty('codLang')) ? (sessionStorage.getItem('codLang')) : 'it_IT',
      token: sessionStorage.getItem('token_download'),
      tabActive: '1'
    }
  },
  mounted: function () {
    this.getMessaggi(true)
    //this.loading = false
  },
  methods: {
    getMessaggi: function (mount) {
      this.$set(this, 'loading', true)
      setTimeout(() => {
        let msg = {
          titolo: '',
          dataPub: '',
          dataExp: '',
          testo: '',
          allegati: []
        }
        //this.$set(this, 'messaggio', msg)
        //this.$set(this, 'msg', msg)
        this.$http.get('communication/' + this.$store.state.country + '/messaggidsh', {
          params: {}
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'messaggiNonLetti', response.body.data.nonLetti)
              this.$set(this, 'messaggiLetti', response.body.data.letti)
              this.$set(this, 'messaggiAnnunci', response.body.data.annunci)
              //this.$set(this, 'messaggiBacheca', response.body.data.bacheca)
              this.$set(this, 'counterNonLetti', parseInt(response.body.attrib.nonLetti))
              this.$set(this, 'counterLetti', parseInt(response.body.attrib.letti))
              this.$set(this, 'counterAnnunci', parseInt(response.body.attrib.annLetti) + parseInt(response.body.attrib.annNonLetti))
              this.$set(this, 'counterAnnunciNonLetti', parseInt(response.body.attrib.annNonLetti))
              //this.$set(this, 'counterBacheca', parseInt(response.body.attrib.bacheca))
              this.$emit('changeCounterNuovi', parseInt(response.body.attrib.nonLetti))
              //this.$emit('changeCounterBacheca', parseInt(response.body.attrib.bacheca))
              this.openTab(this.tabActive)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loading', false)
          }, response => {
            this.$set(this, 'loading', false)
          })
      }, 200)
    },
    isImportant: function (messaggio) {
      if (messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'Y') {
        // Documenti a cui è stata fatta la Presa Visione
        return false
      } else if (messaggio.sePresaVis === 'N' && messaggio.seLetto === 'Y') {
        // Documenti senza Presa Visione che è già stato letto
        return false
      } else {
        return true
      }
    },
    setMessaggioService: function (messaggio, operazione, closeModal) {
      let data = new FormData()
      data.append('id', messaggio.id)
      data.append('op', operazione)
      this.$http.post('communication/' + this.$store.state.country + '/messaggio', data)
        .then(response => {
          if (response.body.rc === 0) {
            // Se op L ricalcolo tutti i messaggi da leggere
            if (operazione === 'L') {
              let messaggiCount = this.$store.state.messaggiCount
              if (messaggiCount[messaggio.tipo] !== undefined && messaggiCount[messaggio.tipo] > 0) {
                messaggiCount[messaggio.tipo] = messaggiCount[messaggio.tipo] - 1
              }
              if (messaggiCount.totale !== undefined && messaggiCount.totale > 0) {
                messaggiCount.totale = messaggiCount.totale - 1
              }
              this.$store.commit('set', { key: 'messaggiCount', value: messaggiCount })
              bus.$emit('changeMessaggiCount')
            }
            this.getMessaggi()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    selectMessage: function (item, index) {
      this.$set(this, 'showModal', true)
      this.$set(this, 'messaggio', item)
      if (item.seLetto === 'N') {
        // Richiamo il servizio di Lettura del documento solo l aprima volta
        this.setMessaggioService(item, 'L', false)
      }
    },
    closeMessages: function () {
      this.$set(this, 'showModal', false)
      let obj = {
        titolo: '',
        dataPub: '',
        dataExp: '',
        testo: '',
        allegati: []
      }
      this.$set(this, 'messaggio', obj)
    },
    openTab: function (tab) {
      this.$set(this, 'tabActive', tab)
      switch (tab) {
        case '1':
          this.$set(this, 'messaggi', this.messaggiNonLetti)
          break;
        case '2':
          this.$set(this, 'messaggi', this.messaggiLetti)
          break;
        case '3':
          this.$set(this, 'messaggi', this.messaggiAnnunci)
          break;
      }
    },
    getTitle: function () {
      switch (this.tabActive) {
        case '1':
          return this.$t('messages.nuovi')
        case '2':
          return this.$t('messages.letti') + ((this.counterLetti > 0) ? (' (' + this.counterLetti + ')') : '')
        case '3':
          return this.$t('messages.annunci') + ((this.counterAnnunci > 0) ? (' (' + this.counterAnnunci + ')') : '')
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="less">
@import "../assets/less/general.less";


.com {
  height: 100%;

  // padding: 10px;
  .com-title {
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
    height: 40px;
    text-align: center;
    margin-bottom: 20px;

    span {
      line-height: 40px;
      height: 40px;
      text-align: center;
      width: calc(100% - 50px);
      .set-font(@color: @rossoRiva, @size: 20px, @family: 'os-regular');
      font-weight: bold;
      letter-spacing: 2px;
      text-transform: uppercase;
      height: 40px;
      letter-spacing: 2px;
      padding-top: 10px;
    }

    /*span {
        display: block;
        text-align: left;
        letter-spacing: 3px;
        text-transform: uppercase;
        .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family:'os-regular');
      }*/
  }

  .box {
    .box-documents {
      overflow: auto;
      padding-bottom: 60px;

      .gridDocs {
        overflow: auto;

        //padding-left: 15px;
        //padding-right: 15px;
        .padding-2 {
          padding-left: 3px;
          padding-right: 3px;
        }
      }

      .gridMessage {
        overflow: auto;
        padding-left: 0px;
        padding-right: 0px;

        .padding-2 {
          padding-left: 3px;
          padding-right: 3px;
        }

        .el-card {
          width: 100%;
          height: 115px;
          float: left;
          margin-bottom: 10px;
          border-radius: 0px;
          padding: 5px 10px !important;
          cursor: pointer;

          .el-card__body {
            padding: 0;
            height: 100%;

            .card-testata {
              width: 100%;
              height: 30px;
              padding: 0 !important;
              display: flex;
              justify-content: space-between;

              .titolo {
                width: 80%;
                .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 14px);
                text-align: left;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .priorita {
                margin-left: 10px;

                .fa-icon {
                  color: red;
                }
              }

              .allegati {
                .fa-icon {
                  color: @greenRiva;
                }
              }

              .ricevuto {
                .set-font(@color: @greenRiva, @size: 10px);
                font-style: italic;
                margin-top: 3px;
              }

              .presa-vis {
                .fa-icon {
                  color: @rossoRiva;
                }
              }

              .presa-vis-yes {
                .fa-icon {
                  color: @greenTick;
                }
              }
            }

            .testo {
              height: 50px;
              padding: 0 5px !important;
              .set-font(@size: 12px; @color: @textTable);
              text-align: left;
              word-break: break-word;
            }

            .footer {
              display: inline-block;

              //position: absolute;
              //bottom: 6px;
              //left: 0;
              //padding: 0 10px !important;
              .data {
                .set-font(@size: 10px);
                float: left;
                line-height: 20px;
                font-style: italic;
                padding-top: 2px;
              }

              .el-button {
                float: right;
                height: 23px;
                line-height: 20px;
                padding: 0 6px;
                border-color: @oroRiva !important;
                background-color: @oroRiva !important;
              }

              .skip {
                float: right;
                margin-right: 2px;
                text-align: right;

                .el-badge {
                  .fa-icon {
                    color: @oroRiva;
                  }

                  .el-badge__content {
                    border: none;
                    background-color: transparent;
                    color: #CBB385;
                    right: 10px;
                  }
                }
              }
            }
          }
        }

        & .selected {
          background-color: @hoverTbl;
        }

        & .important {
          border-left: 3px solid @greenRiva;

          .testo {
            .set-font(@color: @textTable, @size: 12px, @family: 'os-bold') !important;
            word-break: break-word;
          }

          .footer {
            .data {
              .set-font(@color: @greenRiva, @size: 10px, @family: 'os-bold') !important;
              font-style: normal;
            }
          }
        }
      }
    }
  }

  .menu-trasferta {
    z-index: 100;
    background-color: #fff;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 60px;
    color: @grayMedium;
    display: block;
    text-align: left;
    border-top: 1px solid @greyLine;

    //padding-top: 4px;
    //padding-bottom: 4px;
    .action {
      height: 60px;
      width: 33%;
      float: left;
      text-align: center;

      .box {
        height: 54px;
        margin-top: 3px;
        margin-bottom: 3px;

        .boxIcon {
          height: 30px;
          margin-bottom: 5px;

          &.counter-nuovi {
            .el-badge {
              .el-badge__content {
                height: 20px;
                width: 20px;
                top: 8px;
                right: 6px;
                padding: 0;
                line-height: 16px;
                .set-font(@color: @white, @size: 10px);
                letter-spacing: 0;
                background-color: red;
              }
            }
          }

          &.counter-bacheca {
            .el-badge {
              .el-badge__content {
                height: 20px;
                width: 20px;
                top: 8px;
                right: 6px;
                padding: 0;
                line-height: 16px;
                .set-font(@color: @white, @size: 10px);
                letter-spacing: 0;
                background-color: @oroRiva;
              }
            }
          }
        }

        span {
          .set-font(@size: 8px, @color: @grayMedium);
          letter-spacing: 1px;
          line-height: 14px;
          display: block;

          &::first-line {
            line-height: 1;
          }
        }

        &.border-r {
          border-right: 1px solid @greyLine;
        }
      }

      &.selected {
        background-color: #f2fbfb;
        color: @greenRiva !important;

        span {
          color: @greenRiva !important;
        }
      }
    }
  }
}

.modal-message-mobile {
  .custom-dialog {
    height: 80% !important;
    width: 98% !important;
    margin-top: 20% !important;
  }

  .el-dialog {
    .el-dialog__body {
      height: -moz-calc(100% - 200px);
      height: -webkit-calc(100% - 200px);
      height: calc(100% - 200px);
      overflow: auto;
      padding-left: 0px;
      padding-right: 0px;

      .data {
        width: 100%;
        text-align: right;
        margin-top: 10px;
        .set-font(@size: 12px, @color: @textTable);
        font-style: italic;
        padding: 0 4px !important;
      }

      .priorita {
        margin-top: 15px;
        text-align: left;

        .prior-label {
          .set-font(@color: @textTable, @size: 14px, @family: 'os-semibold');
        }

        .prior-value {
          margin-left: 2px;
          .set-font(@color: red, @size: 14px, @family: 'os-semibold');
        }

        .prior-icon {
          .fa-icon {
            color: red;
            margin-top: -4px;
            margin-left: 2px;
          }
        }
      }

      .testo {
        margin-top: 20px;
        .set-font(@color: @textTable, @size: 13px);
        text-align: justify;
        height: auto;
        overflow: auto;
        padding-right: 5px !important;
        word-break: break-word;
      }

      .allegati {
        min-height: 30px;
        max-height: 120px;
        overflow: auto;
        margin-top: 30px;
        margin-bottom: 20px;

        .allegato {
          display: inline-block;

          .icona {
            width: 10%;
            float: left;
            padding-top: 2px;
          }

          .titolo-allegato {
            width: 85%;
            float: left;
            .set-font(@color: @greenRiva, @size: 13px);
            text-align: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .allegato:hover {
          cursor: pointer;
        }
      }
    }

    .el-dialog__footer {
      padding: 10px 0 0;
      height: 160px;

      .footer {
        height: 45px;
        width: 100%;
        padding: 0 !important;

        .scade {
          padding: 10px 0 0 15px;
          .set-font(@color: @textTable, @size: 12px);
          font-style: italic;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MessagesMobile.vue